import './pubsub'
import './drag'
import './clipboard'

/** 防抖函数 */
globalThis.debounce = function (fn, wait) {
    let t
    return (...args) => {
        clearTimeout(t)
        t = setTimeout(() => fn.apply(this, args), wait)
    }
}

/** 节流函数 */
globalThis.throttle = function (fn, delay) {
    let lastCall = 0
    return function (...args) {
        const now = new Date().getTime()
        if (now - lastCall < delay) {
            return
        }
        lastCall = now
        return fn(...args)
    }
}

/** 等待元素 */
globalThis.waitForElement = function (selector, interval = 300, maxAttempts = 50) {
    return new Promise((resolve, reject) => {
        let attempts = 0
        const timer = setInterval(() => {
            const el = document.querySelector(selector)
            if (el) {
                clearInterval(timer)
                resolve(el)
            } else if (++attempts >= maxAttempts) {
                clearInterval(timer)
                reject(new Error('等待元素超时：' + selector))
            }
        }, interval)
    })
}

/** 获取cookie */
globalThis.getCookie = function (key) {
    const cookies = document.cookie.split('; ')
    for (const item of cookies) {
        const index = item.indexOf('=')
        if (index === -1) continue

        const k = item.slice(0, index)
        const v = item.slice(index + 1)

        if (k === key) {
            return decodeURIComponent(v)
        }
    }
    return null
}

/** 读取script[type="application/json"]的json内容 */
globalThis.readJsonFromScript = function (script) {
    if (!script || script.tagName !== 'SCRIPT' || script.type !== 'application/json') {
        throw new Error('元素必须是<script type="application/json">')
    }

    try {
        return JSON.parse(script.textContent)
    } catch (e) {
        throw new Error('解析json失败')
    }
}

globalThis.wait = (t = 0) => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, t)
    })
}